var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.commentsLines.length > 1)?_c('div',_vm._l((_vm.commentsLines),function(line,index){return _c('span',{key:index,staticClass:"d-block mb-2"},[_vm._v(" "+_vm._s(line)+" ")])}),0):_c('span',[_vm._v("No Comments")])])}
var staticRenderFns = []

export { render, staticRenderFns }